import SendIcon from "@mui/icons-material/Send";
import React from "react";
import { AppButton, IAppButtonProps } from "ui/Scripts/source/components/framework/Button/AppButton";

export const SendButton = (props: IAppButtonProps) => (
    <AppButton
        variant="contained"
        startIcon={<SendIcon />}
        {...props}
    >
        {props.children}
    </AppButton>
);
